import React, { useEffect, useState } from 'react';
import IntroComponent from 'src/components/explore/introComponent';
import MainRepplComponent from 'src/components/explore/mainRepplComponent';
import RepplComponent from 'src/components/explore/repplComponent';
import MultiRepplComponent from 'src/components/explore/multiRepplComponent';
import MiniRepplComponent from 'src/components/explore/miniRepplComponent';
import StudioComponent from 'src/components/explore/studioComponent';
import TribeComponent from 'src/components/explore/tribeComponent';
import CollectionsComponent from 'src/components/explore/collectionsComponent';
import TribeDuoComponent from 'src/components/explore/tribeDuoComponent';
import MultiTribeComponent from 'src/components/explore/multiTribeComponent';
import { useIsTablet } from 'src/hooks/use-is-mobile';
import categories from 'src/configs/categories';
import Link from 'next/link';

function Tribes() {
  const isTablet = useIsTablet();
  const [exploreContent, setExploreContent] = useState<any>();

  useEffect(() => {
    const exploreArray = [];
    fetch(
      `https://career.1tm.io/api-json/wp/v2/pages/73693?timestamp=${Date.now()}`
    )
      .then((res) => res.json())
      .then((result) => {
        Object.entries(result.acf).forEach((e: any[]) => {
          exploreArray.push(...e[1]);
        });
        exploreArray.sort(sortCompare);
        setExploreContent(exploreArray);
      });
  }, []);

  useEffect(() => {});

  /* eslint-disable */
  const sortCompare = (a: any, b: any) => {
    var reA = /[^a-zA-Z]/g;
    var reN = /[^0-9]/g;
    var aA = a.order.replace(reA, "");
    var bA = b.order.replace(reA, "");
    if (aA === bA) {
      var aN = parseInt(a.order.replace(reN, ""), 10);
      var bN = parseInt(b.order.replace(reN, ""), 10);
      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
  };
  /* eslint-enable */

  return (
    <div
      style={{ padding: `${isTablet ? '0 0 100px 0' : '0 0 150px 0'}` }}
      className="header-initial div-offest relative overflow-hidden"
    >
      {exploreContent?.map((c) => {
        if (c.section_name === 'intro' && c.display) {
          return <IntroComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'mainRepplComponent' && c.display) {
          return <MainRepplComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'marqueeComponent' && c.display) {
          return <MarqueeComponent key={c.sequence} />;
        }
        if (c.section_name === 'tribeDuoComponent' && c.display) {
          return <TribeDuoComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'multiTribeComponent' && c.display) {
          return <MultiTribeComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'repplComponent' && c.display) {
          return <RepplComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'miniRepplComponent' && c.display) {
          return <MiniRepplComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'multiRepplComponent' && c.display) {
          return <MultiRepplComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'tribeComponent' && c.display) {
          return <TribeComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'studioComponent' && c.display) {
          return <StudioComponent key={c.sequence} data={c} />;
        }
        if (c.section_name === 'collectionComponent' && c.display) {
          return <CollectionsComponent key={c.sequence} data={c} />;
        }
        return <></>;
      })}
    </div>
  );
}

export default Tribes;

const MarqueeComponent = () => {
  const isTablet = useIsTablet();
  const marquees2 = ['animate-marquee', 'animate-marquee2'];
  const [marquees] = useState(marquees2);

  const getPath = (data) => {
    return data?.replace(/ /g, '-');
  };

  return (
    <div style={{ height: '64px' }} className="marquee mt-8 md:mt-20 relative">
      {marquees.map((marquee) => (
        <div
          key={marquee}
          className={`${marquee} absolute top-0 whitespace-nowrap text-blue-300 marquee-child flex`}
        >
          {categories &&
            categories?.map((list) => (
              <Link prefetch={false} href={`/agora/${getPath(list.value)}`}>
                <div
                  style={{ fontSize: `${isTablet ? '48px' : '56px'}` }}
                  className="cursor-pointer"
                >
                  {list.value}
                  <span className="px-2">・</span>
                </div>
              </Link>
            ))}
        </div>
      ))}
    </div>
  );
};
